import { CommandsState, CommandsActionTypes, commandsActionNames } from './types';

export const initialState: CommandsState = {
  commands: [],
  nextCursor: '',
  count: 0,
  showDeviceConfiguration: true,
  fileTypeConfigs: [],
};

export const commandsReducer = (
  state: CommandsState = initialState,
  action: CommandsActionTypes,
): CommandsState => {
  switch (action.type) {
    case commandsActionNames.SET_COMMANDS: {
      return {
        ...state,
        commands: action.payload,
      };
    }
    case commandsActionNames.SET_TOTAL_COUNT: {
      return {
        ...state,
        count: action.payload,
      };
    }
    case commandsActionNames.SET_NEXT_CURSOR: {
      return {
        ...state,
        nextCursor: action.payload,
      };
    }
    case commandsActionNames.CLEAR_COMMANDS: {
      return {
        ...state,
        commands: [],
      };
    }
    case commandsActionNames.SHOW_DEVICE_CONFIGURATION: {
      return {
        ...state,
        showDeviceConfiguration: true,
      };
    }
    case commandsActionNames.HIDE_DEVICE_CONFIGURATION: {
      return {
        ...state,
        showDeviceConfiguration: false,
      };
    }
    case commandsActionNames.SET_FILE_TYPE_CONFIGS: {
      return {
        ...state,
        fileTypeConfigs: action.payload,
      };
    }
    default:
      return state;
  }
};
